import { Tab, Box, Icon, Text } from '@chakra-ui/react';
import { ElementType, useContext } from 'react';
import InvoicesToPayContext from '../contexts/InvoicesToPayContext';

type Props = {
  IconComponent: ElementType;
  text: string;
  color?: string;
  onClick: () => void;
};

const TabNameDisplayed = ({ IconComponent, text, color, onClick }: Props): JSX.Element => {
  const { invoiceSelectionLocked } = useContext(InvoicesToPayContext);
  return (
    <Tab isDisabled={invoiceSelectionLocked}>
      <Box display={'flex'} gap={'8px'} alignItems={'center'} onClick={onClick}>
        <Icon as={IconComponent} boxSize={[4, 4, 5]} color={color} />
        <Text align={'left'} fontSize={['0.875rem', '0.875rem', '1rem']} color={color}>
          {text}
        </Text>
      </Box>
    </Tab>
  );
};

export default TabNameDisplayed;
